import React from 'react';
import Svg, {Path, Rect} from 'react-native-svg';

interface MicIconProps {
  color?: string;
  fillColor?: string;
}

export const MicIcon = ({color = '#1C1C1C', fillColor = 'transparent'}: MicIconProps) => (
  <Svg
    width="44"
    height="44"
    viewBox="0 0 44 44"
    fill="none">
    <Rect width="44" height="44" rx="22" fill={fillColor} />
    <Path
      d="M22 13.667C21.337 13.667 20.7011 13.9304 20.2322 14.3992C19.7634 14.8681 19.5 15.504 19.5 16.167V22.0003C19.5 22.6634 19.7634 23.2993 20.2322 23.7681C20.7011 24.2369 21.337 24.5003 22 24.5003C22.663 24.5003 23.2989 24.2369 23.7678 23.7681C24.2366 23.2993 24.5 22.6634 24.5 22.0003V16.167C24.5 15.504 24.2366 14.8681 23.7678 14.3992C23.2989 13.9304 22.663 13.667 22 13.667Z"
      stroke={color}
      strokeWidth="1.66667"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <Path
      d="M27.8334 20.333V21.9997C27.8334 23.5468 27.2188 25.0305 26.1249 26.1245C25.0309 27.2184 23.5472 27.833 22.0001 27.833C20.453 27.833 18.9693 27.2184 17.8753 26.1245C16.7813 25.0305 16.1667 23.5468 16.1667 21.9997V20.333"
      stroke={color}
      strokeWidth="1.66667"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <Path
      d="M22 27.833V30.333"
      stroke={color}
      strokeWidth="1.66667"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </Svg>
);
